
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";

export const PromotionSection = () => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleCTAClick = () => {
    setIsLoading(true);
    
    // Show toast to indicate user is being redirected
    toast({
      title: "Redirection en cours",
      description: "Vous allez être redirigé vers le guide",
      duration: 3000,
    });
    
    // Simulate a small delay before redirecting
    setTimeout(() => {
      window.open("https://barbara-raux.systeme.io/accueil", "_blank");
      setIsLoading(false);
    }, 500);
  };

  return (
    <section className="bg-gradient-to-r from-[#f8f9fa] to-[#e9ecef] py-12 mt-10 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="md:w-1/2 space-y-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
              Vendre sur le web, par où commencer ?
            </h2>
            <p className="text-gray-600 max-w-lg">
              En suivant ces étapes clairement énoncées, vous serez en mesure de créer votre business en ligne ou votre boutique en ligne. Cette fiche condense les étapes essentielles pour démarrer votre projet.
            </p>
            <div className="pt-2">
              <Button 
                onClick={handleCTAClick}
                size="lg"
                className="group"
                disabled={isLoading}
              >
                {isLoading ? (
                  "Redirection..."
                ) : (
                  <>
                    Télécharger gratuitement
                    <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </>
                )}
              </Button>
            </div>
          </div>
          
          <div className="md:w-1/2">
            <div className="relative mx-auto w-1/2">
              <div className="absolute -top-3 -left-3 bg-[#9b87f5] h-full w-full rounded-lg"></div>
              <img 
                src="/lovable-uploads/7b0f066c-1d98-4cd3-90a0-ecf558767375.png" 
                alt="Vendre sur le web - guide pratique" 
                className="relative rounded-lg shadow-lg object-cover w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
